import { Link } from "@/i18n/routing";
import { IconLinkArrow } from "@repo/assets/images";
import { getStrapiMedia, shimmer, toBase64 } from "@repo/lib/utils";
import Image from "next/image";

const Banner = ({ data }) => {
  const { BannerSlide } = data || {};
  const { title, subtitle, link, desktopMedia, mobileMedia } =
    BannerSlide || {};

  if (!desktopMedia?.file?.url && !mobileMedia?.file?.url) return null;

  const BannerImage = ({ isMobile }) => {
    const media = isMobile ? mobileMedia?.file : desktopMedia?.file;
    if (!media?.url) return null;

    return (
      <Image
        src={getStrapiMedia(media.url)}
        alt={media.alternativeText || `Banner image ${BannerSlide?.id}`}
        width={media.width}
        height={media.height}
        className={`mx-auto ${isMobile ? "h-auto min-h-56 w-full object-center md:hidden" : "hidden md:block"}`}
        placeholder={`data:image/svg+xml;base64,${toBase64(shimmer(media.width, media.height))}`}
        priority={true}
        fetchPriority="high"
        decoding="async"
        loading="eager"
      />
    );
  };

  const BannerOverlay = () => {
    const hasNoContent = !title && !subtitle && !link?.text;
    if (hasNoContent) return null;

    return (
      <div className="group absolute inset-0 z-[2] flex items-center">
        <div className="flex w-full justify-start px-4 md:px-8 lg:px-16">
          <div className="bg-banner-bg rounded-bottom-banner flex max-w-[210px] flex-col gap-2 p-3 md:max-w-[595px] md:justify-center md:gap-3 md:p-6 lg:p-12">
            {title && (
              <h1 className="font-heading rtl:font-arabic text-banner-title text-start text-2xl font-normal md:text-5xl md:leading-tight">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-banner-subTitle text-start text-sm font-medium md:text-3xl md:font-normal">
                {subtitle}
              </p>
            )}
            {link?.text && (
              <div className="text-banner-linkColor mt-2 inline-flex items-center gap-2 text-xs font-medium md:mt-14 md:text-base">
                <span>{link.text}</span>
                <IconLinkArrow className="text-icon-color size-4 fill-current transition-all duration-300 group-hover:translate-x-2 rtl:rotate-180 rtl:group-hover:-translate-x-2" />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="py-5 md:px-4 md:py-8">
      <div className="mx-auto md:max-w-screen-xl">
        <Link
          href={link?.url || "/"}
          aria-label={title || desktopMedia?.file?.alternativeText}
          className="relative block w-full"
        >
          <BannerImage isMobile={true} />
          <BannerImage isMobile={false} />
          <BannerOverlay />
        </Link>
      </div>
    </section>
  );
};

export default Banner;
